export function capitalized(text: string) {
	return text.charAt(0).toUpperCase() + text.slice(1)
}

export function toSnakeCase(text: string) {
	return text.replaceAll(" ", "_").toLowerCase()
}

export const middleTruncate = (text: string, maxLength = 15): string => {
	const length = Math.max(6, maxLength)
	if (text.length <= length) return text
	const initialLength = 3

	const remainingLength = length - initialLength - 3 // 3 for "..."
	if (remainingLength <= 0) {
		return `${text.slice(0, initialLength)}...`
	}

	return `${text.slice(0, initialLength)}...${text.slice(-remainingLength)}`
}
